import React, { useEffect, useRef, useState } from 'react'
import Icon from './Icon'

export interface DropdownOption {
  value: string
  label: string
}

interface DropdownProps {
  options: DropdownOption[]
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select…',
  disabled = false,
}) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [])

  const selected = options.find(o => o.value === value)

  return (
    <div className="dropdown" ref={ref}>
      <button
        type="button"
        className="dropdown__trigger"
        onClick={() => !disabled && setOpen(o => !o)}
        disabled={disabled}
      >
        <span
          className={`dropdown__value ${
            selected ? '' : 'dropdown__value--placeholder'
          }`}
        >
          {selected ? selected.label : placeholder}
        </span>
        <span className="dropdown__arrow">
          <Icon name="chevron-down" size={16} />
        </span>
      </button>

      {open && (
        <ul className="dropdown__menu">
          {options.length === 0 ? (
            <li className="dropdown__empty">No options available</li>
          ) : (
            options.map(o => (
              <li key={o.value}>
                <button
                  type="button"
                  className={`dropdown__option ${
                    o.value === value ? 'dropdown__option--selected' : ''
                  }`}
                  onClick={() => {
                    onChange(o.value)
                    setOpen(false)
                  }}
                >
                  {o.label}
                </button>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  )
}

export default Dropdown
